import api from "./api";

const buildOptionFormData = (payload) => {
  const fd = new FormData();

  fd.append(
    "productId",
    payload.productId ?? ""
  );

  fd.append(
    "optionType",
    payload.optionType ?? ""
  );

  fd.append(
    "value",
    payload.value ?? ""
  );

  fd.append(
    "extraPrice",
    payload.extraPrice ?? 0
  );

  fd.append(
    "quantity",
    payload.quantity ?? 0
  );

  /*
   * חשוב:
   * שולחים גם true וגם false כמחרוזת.
   *
   * לא להשתמש ב:
   * payload.isInStock || true
   *
   * כי false יהפוך ל-true.
   */
  fd.append(
    "isInStock",
    String(payload.isInStock ?? true)
  );

  if (payload.image instanceof File) {
    fd.append(
      "image",
      payload.image
    );
  }

  return fd;
};


export const UpdateProductOption = async (
  optionId,
  payload
) => {
  console.log(
    "Updating product option:",
    {
      optionId,
      productId: payload.productId,
      optionType: payload.optionType,
      value: payload.value,
      extraPrice: payload.extraPrice,
      quantity: payload.quantity,
      isInStock: payload.isInStock,
      image: payload.image,
      isFile:
        payload.image instanceof File,
    }
  );

  const fd =
    buildOptionFormData(payload);

  const response = await api.put(
    `ProductOptions/${optionId}`,
    fd,
    {
      headers: {
        "Content-Type":
          "multipart/form-data",
      },
    }
  );

  return response.data;
};


export const GetProductOptions = async (
  productId
) => {
  const response = await api.get(
    `Product/${productId}/options`
  );

  return response.data;
};


export const DeleteProductOption = async (
  optionId
) => {
  const response = await api.delete(
    `ProductOptions/${optionId}`
  );

  return response.data;
};


export const AddProductOption = async (
  payload
) => {
  const fd =
    buildOptionFormData(payload);

  const response = await api.post(
    "ProductOptions",
    fd,
    {
      headers: {
        "Content-Type":
          "multipart/form-data",
      },
    }
  );

  return response.data;
};